import styled from 'styled-components';

export const ContainerManagedList = styled.div`
  width: 100%;

  .rdt_TableHeadRow {
    color: ${(props) => props.theme.$gray700};
    background-color: ${(props) => props.theme.$gray200};
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 0.2rem 0.2rem 0 0;

    div {
      color: ${(props) => props.theme.$gray700};
      white-space: inherit;
      font-size: 14px;
    }
  }

  .rdt_TableCol:nth-of-type(5) {
    text-align: center;
  }

  .rdt_TableCell {
    padding-bottom: 8px;
    padding-top: 8px;
  }

  .managers {
    gap: 0.3rem;
    img {
      margin-bottom: 0.05rem;
    }

    span {
      margin-top: 0.05rem;
    }
  }
`;
